import { ColorContext, LayoutSizeContext } from 'App';
import PageIndex from 'components/UI/PageIndex';
import { useContext, useState } from 'react';
import { Button, Card, Table } from 'react-bootstrap';
import { FaChevronLeft } from 'react-icons/fa';
import { useGetConnectedDevicesQuery } from 'services/devices/devices.api';
import { displayStatusOptions } from 'utils/iconUtils';

const DeviceHistory = ({
  device,
  selectedDevice,
  widget = false,
  size = null,
  setShowHistory = () => {},
}) => {
  const [pageIndex, setPageIndex] = useState(1);
  const itemAmount = 10;
  const {
    data: connectedDevices = [],
    isLoading: connectedDevicesLoading,
    isError: connectedDevicesError,
  } = useGetConnectedDevicesQuery();
  const theme = useContext(ColorContext);
  const layout = useContext(LayoutSizeContext);

  const deviceDetails = connectedDevices[selectedDevice];

  const historyRows =
    deviceDetails?.data?.slice((pageIndex - 1) * itemAmount, pageIndex * itemAmount) ?? [];

  const totalHistoryItems = deviceDetails?.data?.length ?? 0;
  const maxPages = Math.max(1, Math.ceil(totalHistoryItems / itemAmount));

  return (
    <Card
      className={`shadow-sm ${widget ? 'h-100' : 'mt-3'} border-0 text-white`}
      style={{
        backgroundColor: widget ? theme.primary : theme.primaryShadow,
        height: widget
          ? size === '2x1'
            ? layout.widgetHeight - 90
            : layout.widgetHeight * 2 - 80
          : window.innerHeight / 3 + 50,
        maxHeight: widget ? '100%' : '50%',
      }}
    >
      <Card.Body className="d-flex flex-column h-100">
        <div className="d-flex justify-content-between align-items-center mb-3">
          {widget ? (
            <Button variant="outline-light" size="sm" onClick={() => setShowHistory(false)}>
              <FaChevronLeft />
            </Button>
          ) : (
            <div style={{ width: 25 }} />
          )}
          <div className="text-center">
            <Card.Title className="mb-1">Device History</Card.Title>
            <div className="small">
              {(deviceDetails?.device_type !== 'Manual Road Closure'
                ? deviceDetails?.static_id + ' '
                : '') + deviceDetails?.alias}
              ({deviceDetails?.node_id})
            </div>
          </div>
          <div style={{ width: 25 }} />
        </div>

        <div className="flex-grow-1 overflow-auto">
          {historyRows.length > 0 ? (
            <Table responsive striped hover size="sm" variant="dark" className="align-middle">
              <thead>
                <tr>
                  <th className="text-nowrap">Date/Time</th>
                  <th>Status</th>
                  <th>Source</th>
                  <th>Comment</th>
                </tr>
              </thead>
              <tbody>
                {historyRows.map((data, index) => (
                  <tr key={`${data.ts}-${index}`}>
                    <td>{new Date(data.ts).toLocaleString()}</td>
                    <td>
                      {data.status
                        ? displayStatusOptions(device)[1]
                        : displayStatusOptions(device)[0]}
                    </td>
                    <td>{data?.source ?? '-'}</td>
                    <td className="text-break">
                      {data.comments || <span className="text-muted fst-italic">No info</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div className="d-flex h-100 align-items-center justify-content-center text-muted">
              No Data Available
            </div>
          )}
        </div>

        <PageIndex pageIndex={pageIndex} setPageIndex={setPageIndex} maxPages={maxPages} />
      </Card.Body>
    </Card>
  );
};

export default DeviceHistory;
